/**
 * #486 (item 3): estado de CARREGAMENTO da revisão — enquanto a vista do
 * import não chega, o cartão de idioma e moeda já existe com indicador e
 * `aria-busy="true"`, e «Importar» fica desativado: o dono não avança antes
 * da moeda estar resolvida. Lógica em componente próprio (critério 6 da
 * issue — não cresce o ReviewPanel.tsx).
 *
 * Usa o rodapé REAL (ReviewFooterActions) com canCommit=false: «Importar»
 * aparece desativado, como na revisão com gates abertos.
 */
import { useI18n } from '../../lib/i18n.js'
import { Spinner } from '../../components/ui/index.js'
import { ReviewFooterActions } from './ReviewFooterActions.js'

export function ReviewLoading() {
  const { t } = useI18n()
  return (
    <div className="space-y-5" data-testid="import-review-loading">
      {/* cartão de idioma e moeda em carregamento — mesmo id/estilo do real,
          para o atalho «Resolva a moeda» focar o mesmo alvo */}
      <div
        id="import-currency-card"
        tabIndex={-1}
        aria-busy="true"
        className="rounded-2xl border border-gray-200 bg-white p-4 space-y-2"
      >
        <p className="text-sm font-bold text-gray-900">{t('admin.import.language')}</p>
        <p className="flex items-center gap-2 text-sm text-gray-500">
          <Spinner className="h-4 w-4 text-indigo-500" />
          {t('admin.common.loading')}
        </p>
      </div>
      {/* «Importar» desativado: com a vista pendente não há moeda resolvida
          nem rascunho — o commit não pode partir daqui */}
      <ReviewFooterActions
        hasUnsubmittedReview={false}
        pendingCount={0}
        reviewPending={false}
        onSubmitReview={() => {}}
        mode="append"
        onModeChange={() => {}}
        canCommit={false}
        currencyNeedsConfirm={false}
        commitPending={false}
        onCommit={() => {}}
      />
    </div>
  )
}
